export const Config = {
	backend_uri: import.meta.env.VITE_API_URL || "https://hooky-studio.com/api",
	maintenance_mode: import.meta.env.VITE_MAINTENANCE_MODE === "1",
	google_analytics_id: import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
	sentry_dsn: import.meta.env.VITE_SENTRY_DSN,
	sentry_environment: import.meta.env.MODE,
	app_version: import.meta.env.VITE_APP_VERSION,
	debug: import.meta.env.DEV,
};

const optionalKeys = ["google_analytics_id", "sentry_dsn", "app_version"];

for (const [key, value] of Object.entries(Config)) {
	if (value === undefined && !optionalKeys.includes(key)) {
		console.warn(`Config: "${key}" is undefined — check your .env files`);
	}
}
